import posthog from 'posthog-js';

export function initAnalytics() {
  if (!import.meta.env.VITE_POSTHOG_API_KEY) return;
  posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://app.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false, // we handle page views manually via React Router
  });
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  posthog.identify(userId, traits);
}

export function resetAnalytics() {
  posthog.reset();
}

export function capturePageview(path: string) {
  posthog.capture('$pageview', { $current_url: path });
}
